import React from 'react';
import { Button as MUIButton } from '@material-ui/core';

export default function DoubleButton({
  firstButtonTitle,
  secondButtonTitle,
  isFirstButtonActive,
  isSecondButtonActive,
  firstButtonClick,
  secondButtonClick
}) {
  return(
    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
      <MUIButton
        style={{ height: 40, borderTopRightRadius: 0, borderBottomRightRadius: 0, color: isFirstButtonActive ? '#FFFFFF' : '#757575' }}
        color={isFirstButtonActive ? 'primary' : 'tertiary'}
        variant={isFirstButtonActive ? 'contained' : 'outlined'}
        onClick={firstButtonClick}
      >
        {firstButtonTitle}
      </MUIButton>
      <MUIButton
        style={{ height: 40, borderTopLeftRadius: 0, borderBottomLeftRadius: 0, color: isSecondButtonActive ? '#FFFFFF' : '#757575' }}
        color={isSecondButtonActive ? 'primary' : 'tertiary'}
        variant={isSecondButtonActive ? 'contained' : 'outlined'}
        onClick={secondButtonClick}
      >
        {secondButtonTitle}
      </MUIButton>
    </div>
  );
}